<template>
  <b-modal
    id="modal-warehouse"
    :title="editWarehouse.id ? $t('edit__warhouse') :$t('add__warhouse')"
    cancel-variant="outline-secondary"
    :ok-title="editWarehouse.id ? $t('edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok.prevent="onSubmitWarehouse"
  >
    <b-form>
      <validation-observer ref="warehouseValidations">
        <b-form-group :label="$t('objects__ob')">
          <validation-provider
            #default="{ errors }"
            :name="$t('objects__ob')"
            rules="required"
          >
            <v-select
              v-model="warehouse.object"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="(p) => p.id"
              :options="GET_OBECTS.results"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group :label="$t('namee')">
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.name')"
            rules="required"
          >
            <b-form-input v-model="warehouse.title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group :label="$t('status')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <b-form-checkbox
              v-model="warehouse.is_active"
              checked="true"
              name="check-button"
              class="user-select-none"
              switch
              inline
            >
              {{ warehouse.is_active ? $t('active') : $t('not_active') }}
            </b-form-checkbox>
          </div>
        </b-form-group>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { required } from "@core/utils/validations/validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "AddWarehouse",
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editWarehouse: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {


      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      warehouse: {
        title: "",
        object: null,
        is_active: false,
        is_object: true,
      },
      params: {
        search: null,
        page_size: 5,
        page: 1,
        pagination: 'number'
      },
      // ===============  PRIMARY_DATA_SECTION END ===============


    };
  },
  computed: {
    ...mapGetters("obectsWarehouse", ["GET_OBECTS"]),
  },
  async mounted(){
    await this.FETCH_OBECTS({...this.params})
  },
  methods: {
    ...mapActions("obectsWarehouse", [
      "CREATE_WAREHOUSE",
      "FETCH_WAREHOUSE",
      "UPDATE_WAREHOUSE",
      "FETCH_OBECTS",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.warehouse.user = this.user;

      this.warehouse = {
        title: "",
        object: null,
        is_active: false,
        is_object: true,
      };
      if (!this.editWarehouse) {
        return;
      }
      if (typeof this.editWarehouse === "object" &&this.editWarehouse !== null) {
        this.warehouse.title = this.editWarehouse.title;
        this.warehouse.object = this.editWarehouse.object.id;
        this.warehouse.is_active = this.editWarehouse.is_active;
        this.warehouse.is_object = true;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============








    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmitWarehouse() {
      this.warehouse.user = this.user;
      const success = await this.$refs.warehouseValidations.validate();
      if (!success){
        this.$_errToast({message: this.$t('all_fields_are_required')});
        return;
      }

      const req = {
        id: this.editWarehouse.id,
        data: this.warehouse,
        user: this.user,
      };

      (this.editWarehouse.id
        ? this.UPDATE_WAREHOUSE({ id: req.id, ...req.data })
        : this.CREATE_WAREHOUSE(req.data)
      )
        .then(() => {
          this.$emit("save");
          this.$_okToast().then(() => {
            this.warehouse = {
              title: "",
              object: null,
              is_active: false,
              is_object: true,
            };
            this.$bvModal.hide("modal-warehouse");
          });
        })
        .catch((err) => {
          console.log(err.response)
          if(err && err.response && err.response.status && err.response.status == 400 && err.response.data[0]){
            this.$_errToast({message: err.response.data[0]})
          }
        });

     
    },
    // ===============  ON_SUBMIT_SECTION END ===============




  },
};
</script>

<style scoped>
</style>
